<script>
  import CollapsibleBox1 from './CollapsibleBox1.svelte';
  import CollapsibleBox2 from './CollapsibleBox2.svelte';
  let titre1 = 'Comment obtenir un devis ?';
  let texte1 = ` 
  
  `;
  let titre2 = 'Comment utiliser le configurateur ?';
  let texte2 = `  1. Choisissez tout d’abord quel type de trappe vous souhaitez
          configurer : trappe métallique, trappe alu hydro, trappe vide
          sanitaire, trappe multi-étanchéités, trappe coupe-feu.
          <br />
          2. Vous pouvez ensuite la personnaliser, en choisissant une par une les
          options de votre trappe qui vous sont proposées par SEMIN.
          <br />
          3. Indiquez vos coordonnées
          <br />
          4. Vous serez re-contacter par notre service commercial ou par un de nos distributeurs`;
</script>

<section class="bg-black">
  <div class="as-container mx-auto as-center">
    <div class="as-titre-1">Vous voulez</div>
    <div class="as-titre-2">en savoir plus ?</div>

    <div
      on:click="{() =>
        window.open(
          'https://www.semin.fr/produits/platrerie-isolation/trappes-de-visite'
        )}"
      class="as-btn-rounded as-btn-reverse x-auto"
    >
      Découvrir nos trappes
    </div>

    <div class="grid grid-cols-2 gap-10 mt-20 as-grid">
      <div><CollapsibleBox1 titre="{titre1}" text="{texte1}" /></div>
      <div><CollapsibleBox2 titre="{titre2}" text="{texte2}" /></div>
    </div>
  </div>
</section>

<style>
  .bg-black {
    padding: 80px 0;
    background-color: #000;
  }
  .as-center {
    text-align: center;
  }
  .as-titre-1,
  .as-titre-2 {
    font-family: 'introblack';
    font-size: 102px;
    line-height: 70px;
    text-align: center;
    transition: color 300ms;
  }
  .as-titre-1 {
    -webkit-text-stroke: 2px rgb(209, 209, 209);
    padding-top: 30px;
  }
  .as-titre-2 {
    color: #fff;
    font-size: 115px;
    padding-bottom: 30px;
  }
  .as-btn-rounded.as-btn-reverse {
    color: #000;
    background-color: #fff;
  }
  .as-btn-rounded.as-btn-reverse:hover {
    background-color: #000;
    color: #fff;
    border-color: #fff;
  }

  @media only screen and (max-width: 768px) {
    .bg-black {
      margin-top: 0;
      padding: 30px 0;
    }
    .as-titre-1,
    .as-titre-2 {
      line-height: 8vw;
    }
    .as-titre-1 {
      font-size: 15vw;
    }
    .as-titre-2 {
      font-size: 12vw;
      padding-bottom: 0;
    }
    .as-grid {
      grid-template-columns: none;
      gap: 0;
      margin: 35px 0 20px;
    }
  }
</style>
